export enum SortOrder {
  trending = "trending",
  author_reputation = "author_reputation",
  votes = "votes",
  created = "created"
}
